import * as React from "react";
import { Context } from "./_context";
export const PickUpIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 3c.327 0 .633.16.82.427l2.875 4.107 2.165-1.803L23.14 7.27l-2.723 2.268-1.934 10.642A1 1 0 0 1 17.5 21h-11a1 1 0 0 1-.983-.821L3.581 9.537.86 7.27 2.14 5.73l2.164 1.803 2.876-4.107.075-.096C7.445 3.121 7.715 3 8 3h8ZM7.334 19h9.332l1.637-9H5.698l1.636 9ZM6.421 8H17.58l-2.1-3H8.522l-2.1 3Z", fill: "currentColor" }));
  return iconset[size];
};
PickUpIcon.iconId = "hsXQH1";
